export const trackByProp = <T = any>({
  prop,
  fallback = true,
}: {
  prop: keyof T;
  fallback?: boolean;
}): (<U extends T>(index: number, object: U) => U[typeof prop] | U) =>
  fallback
    ? <U extends T>(index: number, object: U) => object[prop] ?? object
    : <U extends T>(index: number, object: U) => object[prop];

export const trackByValue = <T>(index: number, value: T): T => value;

export const trackByIndex = (index: number, value?: any): number => index;
